interface RightArrowProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export const RightArrow = ({
  width = 16,
  height = 14,
  color = '#1572ED',
  className = '',
}: RightArrowProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1884_14267)">
        <path
          d="M3.75 9.75H12.645L9.9225 13.02C9.85947 13.0958 9.81199 13.1834 9.78277 13.2775C9.75356 13.3717 9.74318 13.4707 9.75223 13.5689C9.77052 13.7673 9.86684 13.9502 10.02 14.0775C10.1732 14.2048 10.3706 14.2661 10.5689 14.2478C10.7673 14.2295 10.9502 14.1332 11.0775 13.98L14.8275 9.48C14.8527 9.44421 14.8753 9.40661 14.895 9.3675C14.895 9.33 14.9325 9.3075 14.9475 9.27C14.9815 9.18401 14.9993 9.09247 15 9C14.9993 8.90753 14.9815 8.816 14.9475 8.73C14.9475 8.6925 14.91 8.67 14.895 8.6325C14.8753 8.5934 14.8527 8.55579 14.8275 8.52L11.0775 4.02C11.007 3.93534 10.9187 3.86725 10.8189 3.82059C10.7191 3.77392 10.6102 3.74982 10.5 3.75C10.3248 3.74966 10.1549 3.81069 10.02 3.9225C9.94406 3.98546 9.88128 4.06279 9.83527 4.15005C9.78925 4.23731 9.7609 4.33279 9.75185 4.43102C9.74279 4.52926 9.7532 4.62831 9.78249 4.72251C9.81177 4.81672 9.85935 4.90422 9.9225 4.98L12.645 8.25H3.75C3.55109 8.25 3.36032 8.32902 3.21967 8.46967C3.07902 8.61032 3 8.80109 3 9C3 9.19891 3.07902 9.38968 3.21967 9.53033C3.36032 9.67098 3.55109 9.75 3.75 9.75Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1884_14267">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
